/**
 * Vuex mutations for the "analytics" module.
 *
 * Currently empty — the module has no local state to mutate; the
 * sendTrackPage action in operations.js reports directly to the API.
 */
export default {

}
